<template>
  <div
    class="ag-header-group-cell-label"
    role="presentation"
  >
    <div
      class="ag-header-cell-label"
      role="presentation"
      @click="onSortRequested"
    >
      <span
        class="ag-header-cell-text ag-header-group-text"
        role="presentation"
        v-html="displayName"
      />

      <span class="ag-sort-indicator-container">
        <span
          class="ag-sort-indicator-icon ag-sort-ascending-icon"
          :class="{ 'ag-hidden': !isSortAsc }"
          aria-hidden="true"
        >
          <span
            class="ag-icon ag-icon-asc"
            unselectable="on"
            role="presentation"
          />
        </span>

        <span
          class="ag-sort-indicator-icon ag-sort-descending-icon"
          :class="{ 'ag-hidden': !isSortDesc }"
          aria-hidden="true"
        >
          <span
            class="ag-icon ag-icon-desc"
            unselectable="on"
            role="presentation"
          />
        </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: { type: Object, required: true },
  },

  data() {
    return {
      api: null,
      column: null,
      sortState: null,
    }
  },

  computed: {
    colId() {
      return this.params?.column?.getColId?.()
    },
    displayName() {
      return this.params?.displayName || ''
    },
    isSortAsc() {
      return this.sortState === 'asc'
    },
    isSortDesc() {
      return this.sortState === 'desc'
    },
  },

  methods: {
    getInitialSortState() {
      if (this.column.isSortAscending()) return (this.sortState = 'asc')
      if (this.column.isSortDescending()) return (this.sortState = 'desc')
      this.sortState = null
      return
    },

    validateOrderArray(array) {
      const isStringArrays = Array.isArray(array) && array.every((item) => typeof item === 'string')
      return isStringArrays ? array : null
    },

    getNextSortState(currentState) {
      const gridOptionSortingOrder = this?.api?.gos?.gridOptions?.sortingOrder
      const columnSortingOrder = this.column?.getColDef().sortingOrder

      const sortingOrder = this.validateOrderArray(columnSortingOrder) ||
        this.validateOrderArray(gridOptionSortingOrder) || ['asc', 'desc', null]

      const currentIndex = sortingOrder.indexOf(currentState)
      const nextIndex = (currentIndex + 1) % sortingOrder.length
      return sortingOrder[nextIndex]
    },

    onSortRequested() {
      this.sortState = this.getNextSortState(this.sortState)
      this.api.applyColumnState({
        state: [
          {
            colId: this.colId,
            sort: this.sortState,
          },
        ],
        defaultState: { sort: null },
      })
    },
  },

  mounted() {
    this.api = this.params.api
    this.column = this.params.column
    this.getInitialSortState()
  },
}
</script>

<style scoped>
.ag-header-group-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}

.ag-header-cell-label {
  cursor: pointer;
}
</style>
